import type { Command, CommandLocal } from "@mapcraft-tasks/client-store";

/**
 * Undo — клиентский стек ОБРАТНЫХ КОМАНД, в пределах вкладки. Серверного op-log нет
 * (ui-spec, шапка): аудит закрыт колонкой `source` в `applied_ops`, возвращать журнал
 * операций незачем.
 *
 * Ложится на стор естественно: undo = обычный `dispatch` обратной команды в ту же
 * очередь. Отдельного механизма отката не нужно и быть не должно — «откат применённого»
 * это и есть тот класс багов, ради избавления от которого выбрана rebase-модель.
 */
/**
 * Обратная команда, при необходимости — со своей локальной нагрузкой (`CommandLocal`).
 * Нужно это ровно одной команде, `restoreDeleted`: она везёт снимок удалённого поддерева,
 * без которого редьюсеру нечем нарисовать возвращённое дерево до ответа сервера.
 */
export type UndoCommand = Command & { local?: CommandLocal };

export type UndoEntry = {
	label: string;
	commands: UndoCommand[];
};

export class UndoStack {
	private entries: UndoEntry[] = [];
	private limit = 100;

	push(entry: UndoEntry): void {
		this.entries.push(entry);
		if (this.entries.length > this.limit) {
			this.entries.shift();
		}
	}

	pop(): UndoEntry | undefined {
		return this.entries.pop();
	}

	/**
	 * Снять верхнюю запись, если она — про это же действие. Нужно там, где действие
	 * отменено не через `undo`, а по ходу дела (брошенный черновик строки): иначе
	 * `Cmd+Z` потом молча съел бы ход, ничего не изменив на экране.
	 */
	popIf(match: (entry: UndoEntry) => boolean): void {
		const top = this.entries[this.entries.length - 1];
		if (top && match(top)) {
			this.entries.pop();
		}
	}

	get depth(): number {
		return this.entries.length;
	}

	clear(): void {
		this.entries = [];
	}
}
